import { createInventoryBrandPage } from "../../../components/create-inventory-brand-page";
import db from "../../../utils/parts-charlynn.json";
export default createInventoryBrandPage("charlynn");

export async function getStaticProps() {
	return { props: { db } };
}
